
import "./osintEvent.scss";
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import MapWithCircles from "../geoMap/GeoMap";
const OsintEvent = (props) => {
    console.log("props", props);
    const event_id = props.post.event_id;
    const phone = props.post.msisdn;
    // We need to remove the leading '+' from the phone number
    const phone_no_plus = phone.startsWith('+') ? phone.substring(1) : phone;

    const verified = false; // Temporary hardcoded verification status
    return (<div className="event">
                <div className="container">
                    <div className="content">
                    {/* Post Head */}
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                            <p>Osint Request {props.post.status} </p>
                            <p>{props.post.timestamp}</p>
                        </div>
                        <div className="header">
                            <p>{props.post.title}</p>
                            <p>{props.post.details}</p>
                        </div>
                        <div>
                        <Link to={{pathname: `/osint/${event_id}`, search: `?phone=${phone_no_plus}`}}  
                        className="event">Event {event_id} - {phone} </Link>
                        </div>
                        
                    </div>
                    <div className="info">
              <div className="item">
                {verified ? <VerifiedIcon /> : <VerifiedOutlinedIcon />}
                3 Verifications
              </div>
              <div className="item">
                <TextsmsOutlinedIcon />
                12 Comments
              </div>
              <div className="item">
                <ShareOutlinedIcon />
                Share
              </div>
            </div>
                </div>
            </div>
    );
};

export default OsintEvent;